import { type ComponentProps } from 'react';
import { ClearFiltersButton, useFilters } from '@elfsight/widget-filters';
import { useLingui } from '@lingui/react/macro';

type ClearButtonProps = ComponentProps<typeof ClearFiltersButton>;

export function ClearButton(props: ClearButtonProps) {
  const { resetFilters } = useFilters();
  const { t } = useLingui();

  return (
    <ClearFiltersButton {...props} onClick={resetFilters}>
      {t`Clear Filters`}
    </ClearFiltersButton>
  );
}
